import { ModDivider } from '@moderneinc/design-system-components';
import { semanticColors } from '@moderneinc/design-system-tokens';
import { Box, styled } from '@mui/material';

export const OpposingBoxes = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'space-between'
}));

export const CenteredOpposingBoxes = styled(OpposingBoxes)(() => ({
  alignItems: 'center'
}));

export const CenteredBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center'
}));

export const InfoBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap'
}));

export const FlexBox = styled('div')(() => ({
  display: 'flex'
})) as typeof Box; //@see https://mui.com/material-ui/migration/upgrade-to-v6/#box

export const RoundedFieldSet = styled('fieldset')(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  borderColor: semanticColors.color.border.primary,
  borderStyle: 'solid',
  borderWidth: 1,
  textAlign: 'left',
  // Fieldsets default to `min-inline-size: min-content`, so non-wrapping content
  // (CodeMirror lines) stretches them past their container — see #8645.
  minWidth: 0
}));

export const RoundedBox = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  borderColor: semanticColors.color.border.primary,
  borderStyle: 'solid',
  borderWidth: 1,
  textAlign: 'left'
}));

export const SpacedDivider = styled(ModDivider)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));
